import React from 'react'
import ImportInvoices from '../../components/import_invoices'

export default function ImportShippingInvoices() {
  const desplegableCompany = [
    {
      label: 'DHL UK Transporte',
      value: 'duk',
    },
    {
      label: 'DPD classic',
      value: 'dpc',
    },
    {
      label: 'Seur',
      value: 'seu',
    },
    {
      label: 'BRT',
      value: 'brt',
    },
    {
      label: 'UPS',
      value: 'eup',
    },
    {
      label: 'GLS Consolidado DE',
      value: 'glc',
    },
    {
      label: 'Fedex',
      value: 'fed',
    },
    {
      label: 'Fedex integrado',
      value: 'fd1',
    },
    {
      label: 'TNT Italia Integrado',
      value: 'tit',
    },
  ]
  const templateImport = 'shipping'

  const data = {
    companies: desplegableCompany,
    template: templateImport,
    labelTemplate: 'Select the shipping company',
    title: 'Import shipping invoices',
  }
  return (
    <>
      <ImportInvoices props={data} />
    </>
  )
}
